/**
 * @file
 * Behaviors for the Header.
 */

!((Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Header behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.header = {
    attach: function() {
      let checkReadyState = setInterval(() => {
        if (document.readyState === 'complete') {
          $('.form-item-search .form-text').attr(
            'placeholder',
            'Keyword Search'
          );
          $('input[id=edit-search--2]').attr('placeholder', 'Keyword Search');
          $('#edit-search--3').attr('placeholder', 'Keyword Search');
          $('#edit-search-api-fulltext').attr('placeholder', 'Keyword Search');
          $('#edit-search-api-fulltext--2').attr(
            'placeholder',
            'Keyword Search'
          );
          $('#edit-search-api-fulltext--3').attr(
            'placeholder',
            'Keyword Search'
          );
          clearInterval(checkReadyState);
        }
      }, 100);

      $('.header__usa-button')
        .off()
        .on('click', function(e) {
          e.preventDefault();
          if (
            $(this)
              .closest('.header__usa-banner')
              .hasClass('banner--open')
          ) {
            $(this)
              .closest('.header__usa-banner')
              .removeClass('banner--open');
            $(this).attr('aria-expanded', false);
            $('#gov-banner').attr('aria-hidden', true);
          }
          else {
            $(this)
              .closest('.header__usa-banner')
              .addClass('banner--open');
            $(this).attr('aria-expanded', true);
            $('#gov-banner').attr('aria-hidden', false);
          }
        });

      $('.header__usa-mobile-banner-button')
        .off()
        .on('click', function(e) {
          e.preventDefault();
          if (
            $(this)
              .closest('.header__usa-banner')
              .hasClass('banner--open')
          ) {
            $(this)
              .closest('.header__usa-banner')
              .removeClass('banner--open');
            $(this)
              .closest('.header__usa-button')
              .attr('aria-expanded', false);
            $('#gov-banner').attr('aria-hidden', true);
          }
          else {
            $(this)
              .closest('.header__usa-banner')
              .addClass('banner--open');
            $(this)
              .closest('.header__usa-button')
              .attr('aria-expanded', true);
            $('#gov-banner').attr('aria-hidden', false);
          }
        });
      $('#edit-search, #edit-search--2, #edit-search--3')
        .on('focus', function() {
          $('.custom-search').css('visibility', 'hidden');
        })
        .on('blur', function() {
          $('.custom-search').css('visibility', 'visible');
        });

      // MegaMenu scroll behavior
      const $window = $(window);
      const $megaMenu = $('.header__nav');
      const $toolbar = $('.toolbar-fixed').length;
      const $fullHeader = $('.header');

      const headerHeight = parseInt($fullHeader.outerHeight());

      $window.scroll(() => {
        if (window.innerWidth <= 768) {
          $megaMenu.css('top', 'unset');
          $megaMenu.css('position', 'relative');
          return;
        }
        if ($window.scrollTop() >= headerHeight) {
          if ($toolbar) {
            $megaMenu.css('top', 79);
            $megaMenu.css('position', 'fixed');
          }
          else {
            $megaMenu.css('top', 0);
            $megaMenu.css('position', 'fixed');
          }
        }
        else {
          $megaMenu.css('top', 'unset');
          $megaMenu.css('position', 'relative');
        }
      });

      //mobile menu behaviors
      $('#mobile-menu').on('click', function() {
        $('.header__nav--mobile').addClass('menu--open');

        // Hide Feedback Widget so that it doesn't block Mobile Nav Elements
        $('._hj-v4Fsu__MinimizedWidgetMiddle__right').css('display', 'none');
      });

      $('#mobile-menu-close').on('click', function() {
        $('.header__nav--mobile').removeClass('menu--open');

        // Show Feedback Widget now that mobile nav is closed
        $('._hj-v4Fsu__MinimizedWidgetMiddle__right').css('display', 'block');
      });

      // Adding +/- icon with span to mobile menu items here instead of
      // menu.html.twig so it doesn't impact other menus.  Span makes it
      // clickable for accordion functionality.
      //
      // If statement added to address multiple <span>/+/- that were appearing
      // in mobile menu on pages with search functionality.
      if (
        $('.header__nav--mobile > .menu > .menu-item > span.fa-solid.fa-plus')
          .length < 1
      ) {
        $('<span class="fa-solid fa-plus"></span>').insertAfter(
          '.header__nav--mobile > .menu > .menu-item > a'
        );
      }

      // Accordion Functionality within Mobile Nav Menu
      $('.header__nav--mobile > .menu > .menu-item span')
        .off()
        .on('click', function(e) {
          e.preventDefault();
          $(this).toggleClass('fa-plus fa-minus');
          if (
            $(this)
              .next('.menu')
              .hasClass('menu--open')
          ) {
            $(this)
              .next('.menu')
              .removeClass('menu--open');
            $(this)
              .next('.menu')
              .attr('aria-expanded', false);
          }
          else {
            $(this)
              .next('.menu')
              .toggleClass('fa-plus fa-minus')
              .addClass('menu--open');
            $(this)
              .next('.menu')
              .attr('aria-expanded', true);
          }
        });

      //adding initial padding to body for mobile
      if (window.innerWidth <= 768) {
        $('body').css('padding-top', headerHeight);
      }

      //window resize listener to adjust body padding for mobile
      //we're throttling to prevent this event from firing too much
      let delay = 500;
      let throttled = false;
      $window.resize(() => {
        if (!throttled) {
          if (window.innerWidth <= 768) {
            //we need to get the height of these at the time of the resize
            $('body').css('padding-top', headerHeight);
          }
          else {
            if ($('body').css('padding-top') !== '0px') {
              $('body').css('padding-top', 0);
            }
          }
          throttled = true;
          // set a timeout to un-throttle
          setTimeout(function() {
            throttled = false;
          }, delay);
        }
      });
    }
  };
})(Drupal, jQuery);
